import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';

type UseIsFoundationalPillarsNavPhase1Enabled = () => boolean;
export const useIsFoundationalPillarsNavPhase1Enabled: UseIsFoundationalPillarsNavPhase1Enabled = () => {
  const treatment = useAndReportExperimentTreatment(Experiment.NavPhase1) as string;

  return ['pillars', 'pillars_header_menu', 'pillars_header_menu_search', 'pillars_header'].includes(treatment);
};
